import { render, staticRenderFns } from "./AppLoad.vue?vue&type=template&id=a05641dc&scoped=true&"
import script from "./AppLoad.vue?vue&type=script&lang=js&"
export * from "./AppLoad.vue?vue&type=script&lang=js&"
import style0 from "./AppLoad.vue?vue&type=style&index=0&id=a05641dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05641dc",
  null
  
)

export default component.exports